import optimizelySDK from '@optimizely/optimizely-sdk';
const optimizelyVanillaSDKInstance = () => {
    let instance;
    return () => {
        var _a;
        if (!instance) {
            instance = optimizelySDK.createInstance({
                sdkKey: process.env.OPTIMIZELY_SDK_KEY,
            });
            optimizelySDK.setLogLevel((_a = process.env.OPTIMIZELY_LOG_LEVEL) !== null && _a !== void 0 ? _a : 'info');
        }
        return instance;
    };
};
export default optimizelyVanillaSDKInstance();
//# sourceMappingURL=getOptimizelyVanillaSDKInstance.js.map